import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Footer } from './Footer';
import { UnifiedNavigation } from './UnifiedNavigation';
import { MobileNavbar } from './MobileNavbar';
import { WelcomePopup } from '../common/WelcomePopup';
import { InteractiveGuide } from '../common/InteractiveGuide';
import { useWelcomePopup } from '../../hooks/useWelcomePopup';
import { useInteractiveGuide } from '../../hooks/useInteractiveGuide';
import { motion } from 'framer-motion';

export const MainLayout: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { isVisible, isNewUser, closePopup } = useWelcomePopup();
  const guide = useInteractiveGuide();
  const location = useLocation();

  // دالة لربط إغلاق نافذة الترحيب ببدء الدليل
  const handleWelcomeClose = () => {
    closePopup();
    // بدء الدليل بعد إغلاق نافذة الترحيب
    guide.startGuideAfterWelcome();
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // مراقبة تغيير المسار لبدء الدليل عند الحاجة
  useEffect(() => {
    // تحقق من وجود علامة في localStorage تشير إلى الحاجة لبدء الدليل
    const shouldStartGuide = localStorage.getItem('shouldStartGuide');
    if (shouldStartGuide === 'true' && location.pathname === '/dashboard') {
      // إزالة العلامة
      localStorage.removeItem('shouldStartGuide');
      // إعادة تعيين حالة الدليل
      guide.resetGuideState();
      // بدء الدليل بالقوة بعد تأخير قصير
      setTimeout(() => {
        guide.forceStartGuideNow();
      }, 500);
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Welcome Popup */}
      <WelcomePopup isVisible={isVisible} onClose={handleWelcomeClose} isNewUser={isNewUser} />

      {/* Interactive Guide */}
      <InteractiveGuide isVisible={guide.isVisible} onClose={guide.closeGuide} steps={guide.steps} currentStep={guide.currentStep} onStepChange={guide.changeStep} onComplete={guide.completeGuide} />

      {/* Mobile Navigation */}
      {isMobile && <MobileNavbar />}

      {/* Desktop Sidebar */}
      {!isMobile && (
        <motion.aside initial={false} animate={{ width: isCollapsed ? 80 : 256 }} className="fixed inset-y-0 right-0 z-20 bg-white shadow-lg">
          <UnifiedNavigation isCollapsed={isCollapsed} onCollapse={() => setIsCollapsed(!isCollapsed)} />
        </motion.aside>
      )}

      {/* Main Content */}
      <motion.div initial={false} animate={{ marginRight: !isMobile ? (isCollapsed ? 80 : 256) : 0 }} className="flex-1 flex flex-col">
        <main className="flex-1 pt-10 px-4 sm:px-6 lg:px-8 py-6">
          <Outlet />
        </main>
        <Footer />
      </motion.div>
    </div>
  );
};
